import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const ProfileInformationLabel = styled(Typography)(({ theme }) => ({
   color: theme.colors["neutral.500"],
   fontFamily: theme.fonts.default,
   fontStyle: "normal",
   fontSize: theme.fontSizes.sm,
   margin: '0 0 .5rem 0'
}));

export const ProfileInformation = styled(Typography)(({ theme }) => ({
   color: theme.colors["neutral.50"],
   fontFamily: theme.fonts.default,
   fontStyle: "normal",
   fontWeight: theme.fontWeights.bold,
   lineHeight: theme.lineHeights.slim,
   fontSize: theme.fontSizes.lg
}));

export const ActionLabel = styled(Typography)(({ theme }) => ({
   color: theme.colors["neutral.50"],
   fontFamily: theme.fonts.default,
   fontStyle: "normal",
   fontSize: theme.fontSizes.md
}));

export const InfoMessageContainer = styled("div")(({ theme }) => ({
   margin: '.5rem 0 .5rem 0',
}));